import React from "react";

const CreditCard = (props) => {
  const { firstNumbers, lastNumbers, name, cvv, valid, id } = props;
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      width="219.502"
      height="129.617"
      viewBox="0 0 219.502 129.617"
      id={id}
    >
      <defs>
        <linearGradient
          id={`linear-gradient${id}`}
          x2="1.054"
          y2="0.947"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" style={{ stopColor: "#6f32ff" }} />
          <stop offset="1" style={{ stopColor: "#00eafb" }} />
        </linearGradient>
        <linearGradient
          id={`linear-gradient-2${id}`}
          x1="0.256"
          y1="-0.175"
          x2="1.143"
          y2="0.294"
          href={`#linear-gradient${id}`}
        />
        <clipPath id={`clip-path${id}`}>
          <rect
            id="Retângulo_33"
            data-name="Retângulo 33"
            width="219.502"
            height="129.617"
            rx="13"
            fill={`url(#linear-gradient${id})`}
          />
        </clipPath>
        <linearGradient
          id={`linear-gradient-3${id}`}
          y1="0.38"
          x2="1.107"
          y2="0.241"
          href={`#linear-gradient${id}`}
        />
        <filter
          id="Caminho_49"
          x="-117.051"
          y="-92.322"
          width="486.356"
          height="421.41"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="30" result="blur" />
          <feFlood style={{ floodOpacity: 0.251 }} />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter
          id="Caminho_48"
          x="-118.543"
          y="-90.333"
          width="429.5"
          height="419.421"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="30" result="blur-2" />
          <feFlood style={{ floodOpacity: 0.251 }} />
          <feComposite operator="in" in2="blur-2" />
          <feComposite in="SourceGraphic" />
        </filter>
        <linearGradient
          id={`linear-gradient-5${id}`}
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" style={{ stopColor: "#f9d423" }} />
          <stop offset="0" style={{ stopColor: "#ffd300" }} />
          <stop offset="1" style={{ stopColor: "#ffb16d" }} />
        </linearGradient>
        <filter
          id="Caminho_47"
          x="-120.273"
          y="-94.625"
          width="331.595"
          height="388.976"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="30" result="blur-3" />
          <feFlood style={{ floodOpacity: 0.251 }} />
          <feComposite operator="in" in2="blur-3" />
          <feComposite in="SourceGraphic" />
        </filter>
        <linearGradient
          id={`linear-gradient-6${id}`}
          y1="-0.103"
          x2="0.365"
          y2="1.524"
          href={`#linear-gradient-5${id}`}
        />
        <filter
          id="Caminho_50"
          x="129.658"
          y="-93.944"
          width="197.857"
          height="193.519"
          filterUnits="userSpaceOnUse"
        >
          <feOffset input="SourceAlpha" />
          <feGaussianBlur stdDeviation="14.5" result="blur-4" />
          <feFlood style={{ floodOpacity: 0.161 }} />
          <feComposite operator="in" in2="blur-4" />
          <feComposite in="SourceGraphic" />
        </filter>
        <linearGradient
          id={`linear-gradient-7${id}`}
          x1="0.699"
          y1="-0.056"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" style={{ stopColor: "#ffee9c" }} />
          <stop offset="0" style={{ stopColor: "#ffe14e" }} />
          <stop offset="1" style={{ stopColor: "#ffd0a7" }} />
        </linearGradient>
        <filter
          id="Elipse_7"
          x="-157.595"
          y="-27.599"
          width="444.894"
          height="444.894"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="37" result="blur-5" />
          <feFlood style={{ floodOpacity: 0.251 }} />
          <feComposite operator="in" in2="blur-5" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Grupo_3503" data-name="Grupo 3503" transform="translate(0)">
        <g id="card3" transform="translate(0 0)">
          <path
            id="background"
            d="M13,0H206.5a13,13,0,0,1,13,13V116.617a13,13,0,0,1-13,13H13a13,13,0,0,1-13-13V13A13,13,0,0,1,13,0Z"
            transform="translate(0 0)"
            fill={`url(#linear-gradient-2${id})`}
          />
          <g
            id="Card_Design"
            data-name="Card Design"
            transform="translate(0 0)"
            style={{ clipPath: `url(#clip-path${id})` }}
          >
            <g
              id="Grupo_38"
              data-name="Grupo 38"
              transform="translate(-40.595 -50.444)"
            >
              <g
                transform="matrix(1, 0, 0, 1, 40.6, 50.44)"
                filter={`url(#Caminho 49${id})`}
              >
                <path
                  id="Caminho_49-2"
                  data-name={`Caminho 49${id}`}
                  d="M0,0S199.545,5.974,244.957,57.011s61.4,150.513,61.4,150.513L69.714,241.41Z"
                  transform="translate(-27.05 -5.32)"
                  fill={`url(#linear-gradient-3${id})`}
                />
              </g>
              <g
                transform="matrix(1, 0, 0, 1, 40.6, 50.44)"
                filter={`url(#Caminho 48${id})`}
              >
                <path
                  id="Caminho_48-2"
                  data-name={`Caminho 48${id}`}
                  d="M0,0S136.213,18.546,181.625,69.583,249.5,205.535,249.5,205.535L12.857,239.421Z"
                  transform="translate(-28.54 -3.33)"
                  fill={`url(#linear-gradient-1${id})`}
                />
              </g>
              <g
                transform="matrix(1, 0, 0, 1, 40.6, 50.44)"
                filter={`url(#Caminho 47${id})`}
              >
                <path
                  id="Caminho_47-2"
                  data-name={`Caminho 47${id}`}
                  d="M9.953,0S80.178,35.939,115.345,78.7s36.25,100.28,36.25,100.28L0,208.976Z"
                  transform="translate(-30.27 -7.63)"
                  fill={`url(#linear-gradient-5${id})`}
                />
              </g>
              <g
                transform="matrix(1, 0, 0, 1, 40.6, 50.44)"
                filter={`url(#Caminho 50${id})`}
              >
                <path
                  id="Caminho_50-2"
                  data-name={`Caminho 50${id}`}
                  d="M0,0S.3,31.2,21.685,57.829s63.846,48.689,63.846,48.689,38.66.542,20.45-20.478S0,0,0,0Z"
                  transform="translate(173.16 -50.44)"
                  fill={`url(#linear-gradient-6${id})`}
                />
              </g>
              <g
                transform="matrix(1, 0, 0, 1, 40.6, 50.44)"
                filter={`url(#Elipse_7)${id}`}
              >
                <ellipse
                  id="Elipse_7-2"
                  data-name={`Elipse 7${id}`}
                  cx="90.996"
                  cy="90.996"
                  rx="90.996"
                  ry="90.996"
                  transform="matrix(-0.26, 0.97, -0.97, -0.26, 176.3, 127.5)"
                  opacity="0.702"
                  fill={`url(#linear-gradient-7${id})`}
                />
              </g>
            </g>
          </g>
        </g>
        <text
          id="Marcos_Baima"
          data-name="Marcos Baima"
          transform="translate(12.19 94.628)"
          fill="#fff"
          style={{
            fontSize: 8,
            fontFamily: "Muli-Bold, Muli",
            fontWeight: 700,
            letterSpacing: "0.012em",
          }}
        >
          <tspan x="0" y="0" style={{ textTransform: "uppercase" }}>
            {name}
          </tspan>
        </text>
        <g
          id="Grupo_3490"
          data-name="Grupo 3490"
          transform="translate(12.74 46.617)"
        >
          <text
            id="_2245_"
            data-name="2245 "
            transform="translate(0 21.427)"
            fill="#fff"
            style={{
              fontSize: 13,
              fontFamily: "Muli-Bold, Muli",
              fontWeight: 600,
              letterSpacing: "0.012em",
            }}
          >
            <tspan x="0" y="0">
              {firstNumbers}{" "}
            </tspan>
          </text>
          <text
            id="_"
            data-name="••••"
            transform="translate(38.588 22)"
            fill="#fff"
            style={{
              fontSize: 20,
              fontFamily: "Muli-Bold, Muli",
              fontWeight: 300,
              letterSpacing: "0.012em",
            }}
          >
            <tspan x="0" y="0">
              ••••
            </tspan>
          </text>
          <text
            id="_2"
            data-name="••••"
            transform="translate(90.577 22)"
            fill="#fff"
            style={{
              fontSize: 20,
              fontFamily: "Muli-Bold, Muli",
              fontWeight: 300,
              letterSpacing: "0.012em",
            }}
          >
            <tspan x="0" y="0">
              ••••
            </tspan>
          </text>
          <text
            id="_6787"
            data-name="6787"
            transform="translate(142.728 21.427)"
            fill="#fff"
            style={{
              fontSize: 13,
              fontFamily: "Muli-Bold, Muli",
              fontWeight: 600,
              letterSpacing: "0.012em",
            }}
          >
            <tspan x="0" y="0">
              {lastNumbers}
            </tspan>
          </text>
        </g>
        <text
          id="CVV"
          transform="translate(161.19 27.628)"
          fill="#fff"
          style={{
            fontSize: 8,
            fontFamily: "Muli-Bold, Muli",
            fontWeight: 700,
            letterSpacing: "0.012em",
          }}
        >
          <tspan x="0" y="0">
            CVV
          </tspan>
        </text>
        <text
          id="_253"
          data-name="253"
          transform="translate(182.19 28.628)"
          fill="#fff"
          style={{
            fontSize: 12,
            fontFamily: "Muli-Bold, Muli",
            fontWeight: 300,
            letterSpacing: "0.012em",
          }}
        >
          <tspan x="0" y="0">
            {cvv}
          </tspan>
        </text>
        <text
          id="VALI"
          transform="translate(148.19 117.628)"
          fill="#fff"
          style={{
            fontSize: 8,
            fontFamily: "Muli-Bold, Muli",
            fontWeight: 700,
            letterSpacing: "0.012em",
          }}
        >
          <tspan x="0" y="0">
            VALI
          </tspan>
        </text>
        <text
          id="_01_21"
          data-name="01/21"
          transform="translate(171.19 118.628)"
          fill="#fff"
          style={{
            fontSize: 12,
            fontFamily: "Muli-Bold, Muli",
            fontWeight: 300,
            letterSpacing: "0.012em",
          }}
        >
          <tspan x="0" y="0">
            {valid}
          </tspan>
        </text>
        <text
          id="MÊS_ANO"
          data-name="MÊS/ANO"
          transform="translate(175.19 105.628)"
          fill="#fff"
          style={{
            fontSize: 5,
            fontFamily: "Muli-Bold, Muli",
            fontWeight: 700,
            letterSpacing: "0.012em",
          }}
        >
          <tspan x="0" y="0">
            MÊS/ANO
          </tspan>
        </text>
      </g>
    </svg>
  );
};

export default CreditCard;
